import ChsIntermediary from 'domain/types/ChsIntermediary';
import Select from 'react-select';

interface IntermediariesOptions {
  value: string;
  label: string;
}

type Props = {
  options: IntermediariesOptions[];
  selectedValues: ChsIntermediary[];
  onSelect: (value: string) => void;
  onRemove: (value: string) => void;
};

const IntermediariesList = ({
  options,
  selectedValues,
  onSelect,
  onRemove,
}: Props) => {
  return (
    <Select
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: '#5b616b',
          borderRadius: 0,
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: '#5b616b',
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: 'none',
        }),
        clearIndicator: (base) => ({
          ...base,
          display: 'none',
        }),
      }}
      options={options}
      placeholder='Select all that apply.'
      value={
        selectedValues
          ? selectedValues.map((o) => ({ value: o.cd, label: o.descr }))
          : []
      }
      isMulti
      onChange={(_, action: any) => {
        switch (action.action) {
          case 'select-option':
            onSelect(action.option.value);
            break;
          case 'remove-value':
            onRemove(action.removedValue.value);
            break;
          case 'clear':
            // TODO Complete?
            break;
        }
      }}
    />
  );
};

export default IntermediariesList;
